/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchProductCodeManagementDetailDownload } from "../../../api/product-code-management/use-product-code";
import { useProductCodeById } from "../../../api/product-code-management/use-product-code-detail";
import { FallbackImage } from "../../../assets/img";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import Button from "../../../components/ui/Button/Button";
import REFTable from "./Section/REFTable";

const REFManagementDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useProductCodeById(id);
  const productCode = data?.data;
  const handleError = ({ currentTarget }) => {
    currentTarget.onerror = null;
    currentTarget.src = FallbackImage;
  };

  const handleBackToList = () => {
    navigate("/product-management/code/");
  };

  const handleGoToProductDetail = () => {
    navigate(`/product-management/product-group/${id}`);
  };

  const onDownload = async () => {
    await fetchProductCodeManagementDetailDownload(id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `product-code-detail-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <div>
      <TitlePage title="코드관리 > REF 관리" />
      <div className="mt-3">
        <h2 className="text-black text-[14px] font-bold">상품정보</h2>
        <div className="mt-[12px]">
          <div className="flex items-center justify-between">
            <div className="w-1/2 h-[130px]">
              <div className="flex border-x border-t border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  상품번호
                </div>
                <div className="bg-white p-3 w-full">
                  {productCode?.productNo}
                </div>
              </div>
              <div className="flex border-x border-t border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  상품 그룹명
                </div>
                <div className="bg-white p-3 w-full">{productCode?.name}</div>
              </div>
              <div className="flex border-x border-t border-b border-primary-grey ">
                <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                  카테고리
                </div>
                <div className="bg-white p-3 w-full">
                  {productCode?.productGroupCategory?.name}
                </div>
              </div>
            </div>
            <div className="w-1/2 h-[130px]">
              <div className="flex items-center border-y border-r border-primary-grey h-full">
                <div className="flex bg-input-grey border-r border-primary-grey w-[40%] p-3 h-full">
                  <span className="my-auto">이미지</span>
                </div>
                <div className="bg-white p-3 w-full">
                  <div className="w-[100px] h-[100px]">
                    <img
                      src={productCode?.mainImage}
                      className="w-full h-full object-fit"
                      onError={handleError}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end w-full mt-[16px]">
            <Button
              onClick={handleBackToList}
              className="border border-title-black w-[80px]"
              text="목록"
            />
            <Button
              onClick={handleGoToProductDetail}
              className="border border-title-black"
              text="상품 상세정보 이동"
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <h2 className="text-black text-[14px] font-bold">REF(상품코드) 정보</h2>
        <div className="mt-[10px]">
          <REFTable onDownload={onDownload} data={productCode?.products} />
        </div>
      </div>
    </div>
  );
};

export default REFManagementDetailPage;
